// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { Component, PropTypes, Children, cloneElement } from 'react';

// import classnames utility
import cx from 'classnames';

// js utility functions
import {assign, merge, isEqual} from 'lodash';

// import modified component from material UI
import MenuItem from '../c_SourceModMenuItem';

// import material UI element with slightly modified source code
import DropDown from '../c_SourceModDropDown';
import DateInput from '../DateInput';
import DropDownMenu from '../c_DropDownMenu';

const dropdownStyle = {
  overflow: 'hidden'
};

const menuCustomization = {
  autoWidth: false,
  menuStyle: {
    overflowX: 'hidden',
    width: '100%',
    backgroundColor: '#fafafa'
  },
  labelStyle: {
    color: '#4a4a4a',
    maxWidth: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: '16px',
    height: '48px'
  },
  listStyle: {
    backgroundColor: '#fafafa',
    fontWeight: 100,
    width: '100%'
  },
  selectedMenuItemStyle: {
    padding: 0,
    color: '#4a4a4a',
    backgroundColor: '#eee'
  },
  popoverStyle: {
    transition: 'transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, top 450ms cubic-bezier(0.23, 1, 0.32, 1), width 1000ms cubic-bezier(0.23, 1, 0.32, 1)'
  }
};

const menuItemCustomization = {
  disableTouchRipple: true,
  disableFocusRipple: true
};

const initState = {
  checked: [],
};

export default class CardFilter extends Component {
  static propTypes = {
    id: PropTypes.any,
    onErrorChange: PropTypes.func,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    menuItems: PropTypes.array.isRequired,
    className: PropTypes.string,
    style: PropTypes.object,
    listStyle: PropTypes.object,
    menuStyle: PropTypes.object,
    containerStyle: PropTypes.object,
    labelStyle: PropTypes.object,
    menuItemCustomization: PropTypes.object,
    selectedMenuItemStyle: PropTypes.object,
    'data-id': PropTypes.string,
    children: PropTypes.object,
    terms: PropTypes.array
  }

  static defaultProps = {
    menuItems: []
  }

  state = initState;

  componentWillReceiveProps(nextProps) {
    // Reset filters when resultes changed.
    if(!isEqual(nextProps.terms, this.props.terms)) {
      this.setState(initState);
    }
  }

  onChange(event, index, value) {
    if (!value) {
      return;
    }

    const primaryText = this.props.menuItems[index-1].name;

    const newCheckedArr = ~this.state.checked.indexOf(value) ?
      this.state.checked.filter(val => val !== value) :
      this.state.checked.concat(value);

    this.setState(
      { ...this.state, checked: newCheckedArr }
    );

    if(this.props.onChange) {
      this.props.onChange(event, newCheckedArr, primaryText, value);
    }

    if(this.props.onBlur) {
      this.props.onBlur(event, newCheckedArr, primaryText, value);
    }
  }

  render() {
    // take out properties that will be overwritten from 'this.props'
    const {
      className,
      onChange,     /* eslint no-unused-vars:0 */
      onBlur,       /* eslint no-unused-vars:0 */
      style,
      'data-id': dataId,
      containerStyle,
      menuItemCustomization: propsMenuItemCustomization,
      selectedMenuItemStyle: propsSelectedMenuItemStyle,
      listStyle: propsListStyle,
      menuStyle: propsMenuStyle,
      labelStyle: propsLabelStyle,
      ...unmodifiedProps
    } = this.props;

    const additionalProps = {
      onChange: ::this.onChange,
      style: merge({}, style, dropdownStyle)
    };

    return (
      <div className={cx('clearfix', 'card-filter-wrapper', className)} style={containerStyle}>
        <DropDown className='card-filter-dropdown'
                  data-id={dataId}
                  checkList
                  {...menuCustomization}
                  {...unmodifiedProps}
                  {...additionalProps}>
          <div className='card-filter-by-container status'>
            <div className='label'>Filter By Status</div>
          </div>
          {
            this.props.menuItems.map((val, index) => {
              return (
                <MenuItem value={val.id}
                  checked={!!~this.state.checked.indexOf(val.id) || this.props.menuItems.length === 1}
                  checkMark
                  className='card-filter-status-item'
                  primaryText={val.name}
                  key={index}
                  data-id={val.name}
                  {...menuItemCustomization}
                  {...propsMenuItemCustomization}/>
              );
            })
          }
        </DropDown>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/common/components/CardFilter/index.js